import { SidePanel, TextButton } from "@wix/design-system";
import { RevertSmall } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../ricos-context";
import { Panel, useClickOutside, usePanelContainerElement } from "./../..";
import { CustomColorPicker } from "./../../color-picker/new-color-picker/components/custom-color-picker";
import { PanelHeader } from "../../panel-header/panel-header";
import { SwatchColorPicker } from "./components/swatch-color-picker";
import { CUSTOM_COLOR_PICKER_MODAL_ID } from "./constants";
import {
  ADD_CUSTOM_COLOR_BUTTON,
  COLOR_PICKER_COLOR_ADDED,
  COLOR_PICKER_COLOR_PREVIEW,
  COLOR_PICKER_COLOR_SELECTED,
  FLOATING_COLOR_SWATCHES,
  RESET_BUTTON
} from "./data-hooks";
import classes from "./new-color-picker-scss";
const NewColorPicker = ({
  title,
  themeColors,
  customColors,
  currentColor,
  closeModal,
  onColorSelected: onColorSelectedProp,
  onColorAdded: onColorAddedProp,
  onColorPreviewStart: onColorPreviewStartProp,
  onColorPreviewEnd,
  onResetColor: onResetColorProp,
  referenceElement,
  logBi
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const containerEl = usePanelContainerElement();
  const [addButtonRef, setAddButtonRef] = useState(null);
  const isCustomColorPickerOpen = () => modalService.isModalOpen(CUSTOM_COLOR_PICKER_MODAL_ID);
  const onColorSelected = (color) => {
    onColorSelectedProp(color);
    logBi({ dataHook: COLOR_PICKER_COLOR_SELECTED, value: color });
  };
  const onColorAdded = (color) => {
    onColorAddedProp(color);
    logBi({ dataHook: COLOR_PICKER_COLOR_ADDED, value: color });
  };
  const onColorPreviewStart = (color) => {
    if (onColorPreviewStartProp) {
      onColorPreviewStartProp(color);
      logBi({ dataHook: COLOR_PICKER_COLOR_PREVIEW, value: color });
    }
  };
  const onResetColor = () => {
    onResetColorProp();
    logBi({ dataHook: RESET_BUTTON });
  };
  useClickOutside({
    containerRef: { current: containerEl },
    onClickOutside: (e) => {
      const target = e.target;
      if (target?.dataset?.hook === "tooltip-text" || target?.role === "tooltip" || containerEl.contains(target) || referenceElement?.contains(target) || isCustomColorPickerOpen()) {
        return;
      }
      closeModal();
    }
  });
  const onAddClick = () => {
    modalService.togglePluginPanel({
      id: CUSTOM_COLOR_PICKER_MODAL_ID,
      Component: CustomColorPicker,
      componentProps: {
        currentColor,
        customColors,
        onColorPreviewStart,
        onColorPreviewEnd,
        onColorAdded,
        referenceElement: addButtonRef
      },
      isMobile,
      positioning: {
        referenceElement: addButtonRef,
        placement: "right-end"
      },
      type: void 0
    });
    logBi({ dataHook: ADD_CUSTOM_COLOR_BUTTON });
  };
  const onCloseButtonClick = () => {
    onColorPreviewEnd?.();
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      onCloseButtonClick,
      dataHook: FLOATING_COLOR_SWATCHES,
      width: isMobile ? "100%" : 288,
      maxHeight: isMobile ? void 0 : 555,
      height: "100%"
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title, className: classes.pickerHeader }),
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      SwatchColorPicker,
      {
        currentColor,
        themeColors,
        customColors,
        onAddClick,
        onColorPreviewStart,
        onColorPreviewEnd,
        onColorSelected,
        setAddButtonRef
      }
    ), /* @__PURE__ */ React.createElement(SidePanel.Footer, { showDivider: true }, /* @__PURE__ */ React.createElement(
      TextButton,
      {
        onClick: () => {
          onResetColor();
          logBi({ dataHook: RESET_BUTTON });
        },
        weight: "normal",
        size: "small",
        dataHook: RESET_BUTTON,
        prefixIcon: /* @__PURE__ */ React.createElement(RevertSmall, null)
      },
      t("ColorPicker_SetToDefault_ButtonLabel")
    )))
  );
};
export {
  NewColorPicker
};
//# sourceMappingURL=new-color-picker.js.map
